import * as Yup from 'yup';

export const validatoinHelper = () => {
  return Yup.object().shape({
    paid_amount: Yup.string().required('مبلغ پرداخت شده اجباری میباشد'),
    tracking_code: Yup.string().required('کد پیگیری اجباری میباشد'),
    payment_date: Yup.string().required("تاریخ پرداخت اجباری میباشد"),
    payment_receipt_image: Yup.string().required("تصویر رسید پرداخت اجباری میباشد"),
  });
};
